import { createContext, useContext } from 'react';

// The one context the mic buttons talk to (Home's centre mic, the round mic bottom right): openVoice opens the panel, voiceActive says a conversation is alive. Both the Ask panel (pure agents,
// redesign) and the older voice window provide it, so a button never needs to know which one is behind it.
export const VoiceModalContext = createContext({ openVoice: () => {}, voiceActive: false });

export function useVoice() {
  return useContext(VoiceModalContext);
}
